import React, { memo, useCallback, useState } from 'react';
import { isSafeUrl } from './markdownUtils';
import styles from './richMarkdown.module.css';

function MarkdownImage({ src, alt, title }) {
    const [previewOpen, setPreviewOpen] = useState(false);
    const safeSrc = isSafeUrl(src) ? src : null;

    const openPreview = useCallback(() => {
        if (safeSrc) setPreviewOpen(true);
    }, [safeSrc]);

    const closePreview = useCallback(() => setPreviewOpen(false), []);

    if (!safeSrc) return null;

    return (
        <>
            <button type="button" className={styles.imageButton} onClick={openPreview} aria-label={alt || 'Open image preview'}>
                <img
                    src={safeSrc}
                    alt={alt || ''}
                    title={title}
                    loading="lazy"
                    decoding="async"
                    className={styles.image}
                />
            </button>
            {previewOpen ? (
                <div
                    className={styles.imageOverlay}
                    role="dialog"
                    aria-modal="true"
                    aria-label={alt || 'Image preview'}
                    onClick={closePreview}
                    onKeyDown={event => {
                        if (event.key === 'Escape') closePreview();
                    }}>
                    <img src={safeSrc} alt={alt || ''} className={styles.imagePreview} />
                </div>
            ) : null}
        </>
    );
}

export default memo(MarkdownImage);
